export const FEATURE_NAMESPACE = 'feature.stoppage-analysis'
